(function(APP, $, window, document) {

	function SinglePost() {
		var iframes = document.querySelectorAll('.blog__article iframe');
		
		iframes.forEach(function(iframe) {
			var iframeContainer = iframe.parentElement;
			iframeContainer.classList.add('blog__article-iframe');
		});
		
		return this;
	}

	$(window).on('load', function() {
		APP.store.singlePost = new SinglePost();
	});

})(APP, jQuery, window, document);
